export var Service;
(function (Service) {
    Service["Pregnancy"] = "pregnancy";
    Service["Manager"] = "manager";
    Service["PrePostOp"] = "pre_post_op";
    Service["Basic"] = "basic";
    Service["Diabetes"] = "diabetes";
})(Service || (Service = {}));
const COLOURS = {
    [Service.Pregnancy]: "violet",
    [Service.Manager]: "lime",
    [Service.PrePostOp]: "info",
    [Service.Basic]: "primary",
    [Service.Diabetes]: "orange",
};
export const getServiceColour = (service) => COLOURS[service];
const FOR_HUMANS = {
    [Service.Pregnancy]: "várandós",
    [Service.Manager]: "menedzser",
    [Service.PrePostOp]: "műtét",
    [Service.Basic]: "alap",
    [Service.Diabetes]: "diabétesz",
};
export const getServiceChoices = (selected) => Object.values(Service)
    .map((service) => ({
    key: service,
    text: FOR_HUMANS[service],
    isSelected: !!(selected === null || selected === void 0 ? void 0 : selected.includes(service)),
}))
    .sort(({ text: a }, { text: b }) => a.localeCompare(b));
export const serviceForHumans = (service) => FOR_HUMANS[service];
